import { useAppSelector } from "@/redux/store/hooks";

const useLiquidTemplateStyles = () => {
  const { liquidTemplates } = useAppSelector((state) => state.liquidTemplates);

  let node = "";

  for (const template of liquidTemplates) {
    if (template.path === "liquid_templates/css") {
      node += template.body;
    }
  }

  return node;
};

export default useLiquidTemplateStyles;
